import Controller from '@ember/controller';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import nameSort from 'scaleflow/utils/nameSort';

export default class BusinessGoalsListController extends Controller {
  @service store;
  @service betaToggle;
  @service intl;

  queryParams = ['search', 'status', 'initiativesLinked'];
  @tracked search = '';
  @tracked status = [];
  @tracked initiativesLinked = [];

  get sortedGoals() {
    return this.model.toSorted((a, b) => nameSort(a.title, b.title));
  }

  get goals() {
    let goals = this.sortedGoals;
    if (this.status.length === 0 && !this.initiativesLinked) {
      return goals;
    }

    if (this.status.length !== 0) {
      goals = goals.filter((goal) => this.status.includes(goal.active));
    }
    if (this.initiativesLinked.length !== 0) {
      goals = goals.filter((goal) =>
        this.initiativesLinked.includes(goal.initiatives.length > 0),
      );
    }
    return goals;
  }

  get goals_without_parents() {
    return this.sortedGoals.filter((goal) => !goal.parent.content);
  }

  get trueFalseOptions() {
    return [
      {
        label: this.intl.t('dictionary.yes'),
        value: true,
      },
      {
        label: this.intl.t('dictionary.no'),
        value: false,
      },
    ];
  }

  get isAMatchCallback() {
    if (!this.search) return () => true;
    return (goal) => {
      return goal.title.toLowerCase().includes(this.search.toLowerCase());
    };
  }
}
